export const filterData = (resultsArr, partDataArr, newArr) => {
  resultsArr.forEach((_, index) => {
    let findData = resultsArr.find(
      (rsulatsData) => rsulatsData.id === partDataArr[index]
    );
    if (!findData) return;
    newArr.push(findData);
  });
};
